import PlainInputCharacter from "./PlainInputCharacter";
import { COLORS, SIZES } from "./utilities";

export { COLORS, SIZES };
export default PlainInputCharacter;
